import {
  core_v1_Transform,
  coreV1ListTransformsInfiniteOptions,
  CoreV1ListTransformsResponse,
} from '@antimatterhq/asl-api-ts-v1';
import { useInfiniteQuery } from '@antimatterhq/ui/hooks/queries/useInfiniteQuery';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { useOptimisticDeleteFromInfiniteQuery } from '@/hooks/query/useOptimisticDeleteFromInfiniteQuery';
import { useOptimisticUpdateFromInfiniteQuery } from '@/hooks/query/useOptimisticUpdateFromInfiniteQuery';

const DEFAULT_LIST_TRANSFORMS_LIMIT = 500;

interface UseGetTransformsInfiniteArgs {
  limit?: number;
}

export const useGetTransformsInfinite = (
  args?: UseGetTransformsInfiniteArgs,
) => {
  const limit = args?.limit ?? DEFAULT_LIST_TRANSFORMS_LIMIT;

  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id || '';

  const queryOptions = coreV1ListTransformsInfiniteOptions({
    ...defaultOptions(),
    path: { workspace },
    query: { limit },
  });

  const queryKey = queryOptions.queryKey;

  const optimisticDelete = useOptimisticDeleteFromInfiniteQuery<
    core_v1_Transform,
    CoreV1ListTransformsResponse
  >(queryKey, limit, (i: core_v1_Transform) => i.metadata?.name ?? '');

  const optimisticUpdate = useOptimisticUpdateFromInfiniteQuery<
    core_v1_Transform,
    CoreV1ListTransformsResponse
  >(queryKey, limit, (i: core_v1_Transform) => i.metadata?.name ?? '');

  const query = useInfiniteQuery({
    ...queryOptions,
    enabled: !!workspace && !!warehouse,
    getNextPageParam: (page) => page?.metadata?.cursor,
  });

  return {
    ...query,
    optimisticDelete,
    optimisticUpdate,
  };
};
